<template>
  <n-modal class="modal-add-access" :loading="$var('load')" @close="$emit('close')">
    <h3>Добавить Полномочия</h3>
    <n-form @submit="submit">
      <n-items>
        <n-select title="Полномочие" :data="types" v-bind="$form.input('type', 'select')"
                  item-value="name" option-title="description" selected-title="description" />
        <n-button color="primary" wide type="submit">Назначить</n-button>
      </n-items>
    </n-form>
  </n-modal>
</template>

<script>
export default {
  name: 'ModalAddAccess',
  props: [ 'project', 'user', ],
  data: () => ({
    types: [],
  }),
  created() {
    this.$form.init({
      type: null,
    })
    this.loadData()
  },
  methods: {
    loadData() {
      this.$var('load', true)
      $api.iq.accesses.participants.tree().then((result) => {
        this.types = result.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
    submit() {
      this.$var('load', true)
      const data = {
        type: this.$form.get('type.name'),
      }
      $api.iq.accesses.participants.create(this.project.id, this.user.id, data).then((response) => {
        $app.store.action('app.updateUser').finally(() => {
          this.$emit('close')
          this.$emit('submit')
        })
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .modal-add-access {
  
  }
</style>
